/* tslint:disable */
/* eslint-disable */
/**
 * Kubernetes
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: unversioned
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import * as runtime from '../runtime';
import { IoK8sApiAppsV1ControllerRevisionFromJSON, IoK8sApiAppsV1ControllerRevisionToJSON, IoK8sApiAppsV1ControllerRevisionListFromJSON, IoK8sApiAppsV1DaemonSetFromJSON, IoK8sApiAppsV1DaemonSetToJSON, IoK8sApiAppsV1DaemonSetListFromJSON, IoK8sApiAppsV1DeploymentFromJSON, IoK8sApiAppsV1DeploymentToJSON, IoK8sApiAppsV1DeploymentListFromJSON, IoK8sApiAppsV1ReplicaSetFromJSON, IoK8sApiAppsV1ReplicaSetToJSON, IoK8sApiAppsV1ReplicaSetListFromJSON, IoK8sApiAppsV1StatefulSetFromJSON, IoK8sApiAppsV1StatefulSetToJSON, IoK8sApiAppsV1StatefulSetListFromJSON, IoK8sApiAutoscalingV1ScaleFromJSON, IoK8sApiAutoscalingV1ScaleToJSON, IoK8sApimachineryPkgApisMetaV1APIResourceListFromJSON, IoK8sApimachineryPkgApisMetaV1DeleteOptionsToJSON, IoK8sApimachineryPkgApisMetaV1StatusFromJSON, IoK8sApimachineryPkgApisMetaV1WatchEventFromJSON, } from '../models/index';
/**
 *
 */
export class AppsV1Api extends runtime.BaseAPI {
    /**
     * create a ControllerRevision
     */
    async createAppsV1NamespacedControllerRevisionRaw(requestParameters, initOverrides) {
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling createAppsV1NamespacedControllerRevision.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling createAppsV1NamespacedControllerRevision.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.dryRun !== undefined) {
            queryParameters['dryRun'] = requestParameters.dryRun;
        }
        if (requestParameters.fieldManager !== undefined) {
            queryParameters['fieldManager'] = requestParameters.fieldManager;
        }
        if (requestParameters.fieldValidation !== undefined) {
            queryParameters['fieldValidation'] = requestParameters.fieldValidation;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = '**';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/apis/apps/v1/namespaces/{namespace}/controllerrevisions`.replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IoK8sApiAppsV1ControllerRevisionToJSON(requestParameters.body),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiAppsV1ControllerRevisionFromJSON(jsonValue));
    }
    /**
     * create a ControllerRevision
     */
    async createAppsV1NamespacedControllerRevision(requestParameters, initOverrides) {
        const response = await this.createAppsV1NamespacedControllerRevisionRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * create a DaemonSet
     */
    async createAppsV1NamespacedDaemonSetRaw(requestParameters, initOverrides) {
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling createAppsV1NamespacedDaemonSet.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling createAppsV1NamespacedDaemonSet.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.dryRun !== undefined) {
            queryParameters['dryRun'] = requestParameters.dryRun;
        }
        if (requestParameters.fieldManager !== undefined) {
            queryParameters['fieldManager'] = requestParameters.fieldManager;
        }
        if (requestParameters.fieldValidation !== undefined) {
            queryParameters['fieldValidation'] = requestParameters.fieldValidation;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = '**';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/apis/apps/v1/namespaces/{namespace}/daemonsets`.replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IoK8sApiAppsV1DaemonSetToJSON(requestParameters.body),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiAppsV1DaemonSetFromJSON(jsonValue));
    }
    /**
     * create a DaemonSet
     */
    async createAppsV1NamespacedDaemonSet(requestParameters, initOverrides) {
        const response = await this.createAppsV1NamespacedDaemonSetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * create a Deployment
     */
    async createAppsV1NamespacedDeploymentRaw(requestParameters, initOverrides) {
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling createAppsV1NamespacedDeployment.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling createAppsV1NamespacedDeployment.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.dryRun !== undefined) {
            queryParameters['dryRun'] = requestParameters.dryRun;
        }
        if (requestParameters.fieldManager !== undefined) {
            queryParameters['fieldManager'] = requestParameters.fieldManager;
        }
        if (requestParameters.fieldValidation !== undefined) {
            queryParameters['fieldValidation'] = requestParameters.fieldValidation;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = '**';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/apis/apps/v1/namespaces/{namespace}/deployments`.replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IoK8sApiAppsV1DeploymentToJSON(requestParameters.body),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiAppsV1DeploymentFromJSON(jsonValue));
    }
    /**
     * create a Deployment
     */
    async createAppsV1NamespacedDeployment(requestParameters, initOverrides) {
        const response = await this.createAppsV1NamespacedDeploymentRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * create a ReplicaSet
     */
    async createAppsV1NamespacedReplicaSetRaw(requestParameters, initOverrides) {
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling createAppsV1NamespacedReplicaSet.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling createAppsV1NamespacedReplicaSet.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.dryRun !== undefined) {
            queryParameters['dryRun'] = requestParameters.dryRun;
        }
        if (requestParameters.fieldManager !== undefined) {
            queryParameters['fieldManager'] = requestParameters.fieldManager;
        }
        if (requestParameters.fieldValidation !== undefined) {
            queryParameters['fieldValidation'] = requestParameters.fieldValidation;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = '**';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/apis/apps/v1/namespaces/{namespace}/replicasets`.replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IoK8sApiAppsV1ReplicaSetToJSON(requestParameters.body),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiAppsV1ReplicaSetFromJSON(jsonValue));
    }
    /**
     * create a ReplicaSet
     */
    async createAppsV1NamespacedReplicaSet(requestParameters, initOverrides) {
        const response = await this.createAppsV1NamespacedReplicaSetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * create a StatefulSet
     */
    async createAppsV1NamespacedStatefulSetRaw(requestParameters, initOverrides) {
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling createAppsV1NamespacedStatefulSet.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling createAppsV1NamespacedStatefulSet.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.dryRun !== undefined) {
            queryParameters['dryRun'] = requestParameters.dryRun;
        }
        if (requestParameters.fieldManager !== undefined) {
            queryParameters['fieldManager'] = requestParameters.fieldManager;
        }
        if (requestParameters.fieldValidation !== undefined) {
            queryParameters['fieldValidation'] = requestParameters.fieldValidation;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = '**';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/apis/apps/v1/namespaces/{namespace}/statefulsets`.replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IoK8sApiAppsV1StatefulSetToJSON(requestParameters.body),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiAppsV1StatefulSetFromJSON(jsonValue));
    }
    /**
     * create a StatefulSet
     */
    async createAppsV1NamespacedStatefulSet(requestParameters, initOverrides) {
        const response = await this.createAppsV1NamespacedStatefulSetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * delete collection of ControllerRevision
     */
    async deleteAppsV1CollectionNamespacedControllerRevisionRaw(requestParameters, initOverrides) {
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling deleteAppsV1CollectionNamespacedControllerRevision.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters._continue !== undefined) {
            queryParameters['continue'] = requestParameters._continue;
        }
        if (requestParameters.dryRun !== undefined) {
            queryParameters['dryRun'] = requestParameters.dryRun;
        }
        if (requestParameters.fieldSelector !== undefined) {
            queryParameters['fieldSelector'] = requestParameters.fieldSelector;
        }
        if (requestParameters.gracePeriodSeconds !== undefined) {
            queryParameters['gracePeriodSeconds'] = requestParameters.gracePeriodSeconds;
        }
        if (requestParameters.labelSelector !== undefined) {
            queryParameters['labelSelector'] = requestParameters.labelSelector;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.orphanDependents !== undefined) {
            queryParameters['orphanDependents'] = requestParameters.orphanDependents;
        }
        if (requestParameters.propagationPolicy !== undefined) {
            queryParameters['propagationPolicy'] = requestParameters.propagationPolicy;
        }
        if (requestParameters.resourceVersion !== undefined) {
            queryParameters['resourceVersion'] = requestParameters.resourceVersion;
        }
        if (requestParameters.resourceVersionMatch !== undefined) {
            queryParameters['resourceVersionMatch'] = requestParameters.resourceVersionMatch;
        }
        if (requestParameters.timeoutSeconds !== undefined) {
            queryParameters['timeoutSeconds'] = requestParameters.timeoutSeconds;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = '**';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/apis/apps/v1/namespaces/{namespace}/controllerrevisions`.replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: IoK8sApimachineryPkgApisMetaV1DeleteOptionsToJSON(requestParameters.body),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApimachineryPkgApisMetaV1StatusFromJSON(jsonValue));
    }
    /**
     * delete collection of ControllerRevision
     */
    async deleteAppsV1CollectionNamespacedControllerRevision(requestParameters, initOverrides) {
        const response = await this.deleteAppsV1CollectionNamespacedControllerRevisionRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * delete collection of DaemonSet
     */
    async deleteAppsV1CollectionNamespacedDaemonSetRaw(requestParameters, initOverrides) {
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling deleteAppsV1CollectionNamespacedDaemonSet.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters._continue !== undefined) {
            queryParameters['continue'] = requestParameters._continue;
        }
        if (requestParameters.dryRun !== undefined) {
            queryParameters['dryRun'] = requestParameters.dryRun;
        }
        if (requestParameters.fieldSelector !== undefined) {
            queryParameters['fieldSelector'] = requestParameters.fieldSelector;
        }
        if (requestParameters.gracePeriodSeconds !== undefined) {
            queryParameters['gracePeriodSeconds'] = requestParameters.gracePeriodSeconds;
        }
        if (requestParameters.labelSelector !== undefined) {
            queryParameters['labelSelector'] = requestParameters.labelSelector;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.orphanDependents !== undefined) {
            queryParameters['orphanDependents'] = requestParameters.orphanDependents;
        }
        if (requestParameters.propagationPolicy !== undefined) {
            queryParameters['propagationPolicy'] = requestParameters.propagationPolicy;
        }
        if (requestParameters.resourceVersion !== undefined) {
            queryParameters['resourceVersion'] = requestParameters.resourceVersion;
        }
        if (requestParameters.resourceVersionMatch !== undefined) {
            queryParameters['resourceVersionMatch'] = requestParameters.resourceVersionMatch;
        }
        if (requestParameters.timeoutSeconds !== undefined) {
            queryParameters['timeoutSeconds'] = requestParameters.timeoutSeconds;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = '**';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/apis/apps/v1/namespaces/{namespace}/daemonsets`.replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: IoK8sApimachineryPkgApisMetaV1DeleteOptionsToJSON(requestParameters.body),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApimachineryPkgApisMetaV1StatusFromJSON(jsonValue));
    }
    /**
     * delete collection of DaemonSet
     */
    async deleteAppsV1CollectionNamespacedDaemonSet(requestParameters, initOverrides) {
        const response = await this.deleteAppsV1CollectionNamespacedDaemonSetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * delete collection of Deployment
     */
    async deleteAppsV1CollectionNamespacedDeploymentRaw(requestParameters, initOverrides) {
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling deleteAppsV1CollectionNamespacedDeployment.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters._continue !== undefined) {
            queryParameters['continue'] = requestParameters._continue;
        }
        if (requestParameters.dryRun !== undefined) {
            queryParameters['dryRun'] = requestParameters.dryRun;
        }
        if (requestParameters.fieldSelector !== undefined) {
            queryParameters['fieldSelector'] = requestParameters.fieldSelector;
        }
        if (requestParameters.gracePeriodSeconds !== undefined) {
            queryParameters['gracePeriodSeconds'] = requestParameters.gracePeriodSeconds;
        }
        if (requestParameters.labelSelector !== undefined) {
            queryParameters['labelSelector'] = requestParameters.labelSelector;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.orphanDependents !== undefined) {
            queryParameters['orphanDependents'] = requestParameters.orphanDependents;
        }
        if (requestParameters.propagationPolicy !== undefined) {
            queryParameters['propagationPolicy'] = requestParameters.propagationPolicy;
        }
        if (requestParameters.resourceVersion !== undefined) {
            queryParameters['resourceVersion'] = requestParameters.resourceVersion;
        }
        if (requestParameters.resourceVersionMatch !== undefined) {
            queryParameters['resourceVersionMatch'] = requestParameters.resourceVersionMatch;
        }
        if (requestParameters.timeoutSeconds !== undefined) {
            queryParameters['timeoutSeconds'] = requestParameters.timeoutSeconds;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = '**';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/apis/apps/v1/namespaces/{namespace}/deployments`.replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: IoK8sApimachineryPkgApisMetaV1DeleteOptionsToJSON(requestParameters.body),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApimachineryPkgApisMetaV1StatusFromJSON(jsonValue));
    }
    /**
     * delete collection of Deployment
     */
    async deleteAppsV1CollectionNamespacedDeployment(requestParameters, initOverrides) {
        const response = await this.deleteAppsV1CollectionNamespacedDeploymentRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * delete collection of ReplicaSet
     */
    async deleteAppsV1CollectionNamespacedReplicaSetRaw(requestParameters, initOverrides) {
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling deleteAppsV1CollectionNamespacedReplicaSet.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters._continue !== undefined) {
            queryParameters['continue'] = requestParameters._continue;
        }
        if (requestParameters.dryRun !== undefined) {
            queryParameters['dryRun'] = requestParameters.dryRun;
        }
        if (requestParameters.fieldSelector !== undefined) {
            queryParameters['fieldSelector'] = requestParameters.fieldSelector;
        }
        if (requestParameters.gracePeriodSeconds !== undefined) {
            queryParameters['gracePeriodSeconds'] = requestParameters.gracePeriodSeconds;
        }
        if (requestParameters.labelSelector !== undefined) {
            queryParameters['labelSelector'] = requestParameters.labelSelector;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.orphanDependents !== undefined) {
            queryParameters['orphanDependents'] = requestParameters.orphanDependents;
        }
        if (requestParameters.propagationPolicy !== undefined) {
            queryParameters['propagationPolicy'] = requestParameters.propagationPolicy;
        }
        if (requestParameters.resourceVersion !== undefined) {
            queryParameters['resourceVersion'] = requestParameters.resourceVersion;
        }
        if (requestParameters.resourceVersionMatch !== undefined) {
            queryParameters['resourceVersionMatch'] = requestParameters.resourceVersionMatch;
        }
        if (requestParameters.timeoutSeconds !== undefined) {
            queryParameters['timeoutSeconds'] = requestParameters.timeoutSeconds;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = '**';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/apis/apps/v1/namespaces/{namespace}/replicasets`.replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: IoK8sApimachineryPkgApisMetaV1DeleteOptionsToJSON(requestParameters.body),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApimachineryPkgApisMetaV1StatusFromJSON(jsonValue));
    }
    /**
     * delete collection of ReplicaSet
     */
    async deleteAppsV1CollectionNamespacedReplicaSet(requestParameters, initOverrides) {
        const response = await this.deleteAppsV1CollectionNamespacedReplicaSetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * delete collection of StatefulSet
     */
    async deleteAppsV1CollectionNamespacedStatefulSetRaw(requestParameters, initOverrides) {
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling deleteAppsV1CollectionNamespacedStatefulSet.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters._continue !== undefined) {
            queryParameters['continue'] = requestParameters._continue;
        }
        if (requestParameters.dryRun !== undefined) {
            queryParameters['dryRun'] = requestParameters.dryRun;
        }
        if (requestParameters.fieldSelector !== undefined) {
            queryParameters['fieldSelector'] = requestParameters.fieldSelector;
        }
        if (requestParameters.gracePeriodSeconds !== undefined) {
            queryParameters['gracePeriodSeconds'] = requestParameters.gracePeriodSeconds;
        }
        if (requestParameters.labelSelector !== undefined) {
            queryParameters['labelSelector'] = requestParameters.labelSelector;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.orphanDependents !== undefined) {
            queryParameters['orphanDependents'] = requestParameters.orphanDependents;
        }
        if (requestParameters.propagationPolicy !== undefined) {
            queryParameters['propagationPolicy'] = requestParameters.propagationPolicy;
        }
        if (requestParameters.resourceVersion !== undefined) {
            queryParameters['resourceVersion'] = requestParameters.resourceVersion;
        }
        if (requestParameters.resourceVersionMatch !== undefined) {
            queryParameters['resourceVersionMatch'] = requestParameters.resourceVersionMatch;
        }
        if (requestParameters.timeoutSeconds !== undefined) {
            queryParameters['timeoutSeconds'] = requestParameters.timeoutSeconds;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = '**';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/apis/apps/v1/namespaces/{namespace}/statefulsets`.replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: IoK8sApimachineryPkgApisMetaV1DeleteOptionsToJSON(requestParameters.body),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApimachineryPkgApisMetaV1StatusFromJSON(jsonValue));
    }
    /**
     * delete collection of StatefulSet
     */
    async deleteAppsV1CollectionNamespacedStatefulSet(requestParameters, initOverrides) {
        const response = await this.deleteAppsV1CollectionNamespacedStatefulSetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * delete a ControllerRevision
     */
    async deleteAppsV1NamespacedControllerRevisionRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling deleteAppsV1NamespacedControllerRevision.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling deleteAppsV1NamespacedControllerRevision.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.dryRun !== undefined) {
            queryParameters['dryRun'] = requestParameters.dryRun;
        }
        if (requestParameters.gracePeriodSeconds !== undefined) {
            queryParameters['gracePeriodSeconds'] = requestParameters.gracePeriodSeconds;
        }
        if (requestParameters.orphanDependents !== undefined) {
            queryParameters['orphanDependents'] = requestParameters.orphanDependents;
        }
        if (requestParameters.propagationPolicy !== undefined) {
            queryParameters['propagationPolicy'] = requestParameters.propagationPolicy;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = '**';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/apis/apps/v1/namespaces/{namespace}/controllerrevisions/{name}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: IoK8sApimachineryPkgApisMetaV1DeleteOptionsToJSON(requestParameters.body),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApimachineryPkgApisMetaV1StatusFromJSON(jsonValue));
    }
    /**
     * delete a ControllerRevision
     */
    async deleteAppsV1NamespacedControllerRevision(requestParameters, initOverrides) {
        const response = await this.deleteAppsV1NamespacedControllerRevisionRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * delete a DaemonSet
     */
    async deleteAppsV1NamespacedDaemonSetRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling deleteAppsV1NamespacedDaemonSet.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling deleteAppsV1NamespacedDaemonSet.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.dryRun !== undefined) {
            queryParameters['dryRun'] = requestParameters.dryRun;
        }
        if (requestParameters.gracePeriodSeconds !== undefined) {
            queryParameters['gracePeriodSeconds'] = requestParameters.gracePeriodSeconds;
        }
        if (requestParameters.orphanDependents !== undefined) {
            queryParameters['orphanDependents'] = requestParameters.orphanDependents;
        }
        if (requestParameters.propagationPolicy !== undefined) {
            queryParameters['propagationPolicy'] = requestParameters.propagationPolicy;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = '**';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/apis/apps/v1/namespaces/{namespace}/daemonsets/{name}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: IoK8sApimachineryPkgApisMetaV1DeleteOptionsToJSON(requestParameters.body),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApimachineryPkgApisMetaV1StatusFromJSON(jsonValue));
    }
    /**
     * delete a DaemonSet
     */
    async deleteAppsV1NamespacedDaemonSet(requestParameters, initOverrides) {
        const response = await this.deleteAppsV1NamespacedDaemonSetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * delete a Deployment
     */
    async deleteAppsV1NamespacedDeploymentRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling deleteAppsV1NamespacedDeployment.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling deleteAppsV1NamespacedDeployment.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.dryRun !== undefined) {
            queryParameters['dryRun'] = requestParameters.dryRun;
        }
        if (requestParameters.gracePeriodSeconds !== undefined) {
            queryParameters['gracePeriodSeconds'] = requestParameters.gracePeriodSeconds;
        }
        if (requestParameters.orphanDependents !== undefined) {
            queryParameters['orphanDependents'] = requestParameters.orphanDependents;
        }
        if (requestParameters.propagationPolicy !== undefined) {
            queryParameters['propagationPolicy'] = requestParameters.propagationPolicy;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = '**';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/apis/apps/v1/namespaces/{namespace}/deployments/{name}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: IoK8sApimachineryPkgApisMetaV1DeleteOptionsToJSON(requestParameters.body),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApimachineryPkgApisMetaV1StatusFromJSON(jsonValue));
    }
    /**
     * delete a Deployment
     */
    async deleteAppsV1NamespacedDeployment(requestParameters, initOverrides) {
        const response = await this.deleteAppsV1NamespacedDeploymentRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * delete a ReplicaSet
     */
    async deleteAppsV1NamespacedReplicaSetRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling deleteAppsV1NamespacedReplicaSet.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling deleteAppsV1NamespacedReplicaSet.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.dryRun !== undefined) {
            queryParameters['dryRun'] = requestParameters.dryRun;
        }
        if (requestParameters.gracePeriodSeconds !== undefined) {
            queryParameters['gracePeriodSeconds'] = requestParameters.gracePeriodSeconds;
        }
        if (requestParameters.orphanDependents !== undefined) {
            queryParameters['orphanDependents'] = requestParameters.orphanDependents;
        }
        if (requestParameters.propagationPolicy !== undefined) {
            queryParameters['propagationPolicy'] = requestParameters.propagationPolicy;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = '**';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/apis/apps/v1/namespaces/{namespace}/replicasets/{name}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: IoK8sApimachineryPkgApisMetaV1DeleteOptionsToJSON(requestParameters.body),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApimachineryPkgApisMetaV1StatusFromJSON(jsonValue));
    }
    /**
     * delete a ReplicaSet
     */
    async deleteAppsV1NamespacedReplicaSet(requestParameters, initOverrides) {
        const response = await this.deleteAppsV1NamespacedReplicaSetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * delete a StatefulSet
     */
    async deleteAppsV1NamespacedStatefulSetRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling deleteAppsV1NamespacedStatefulSet.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling deleteAppsV1NamespacedStatefulSet.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.dryRun !== undefined) {
            queryParameters['dryRun'] = requestParameters.dryRun;
        }
        if (requestParameters.gracePeriodSeconds !== undefined) {
            queryParameters['gracePeriodSeconds'] = requestParameters.gracePeriodSeconds;
        }
        if (requestParameters.orphanDependents !== undefined) {
            queryParameters['orphanDependents'] = requestParameters.orphanDependents;
        }
        if (requestParameters.propagationPolicy !== undefined) {
            queryParameters['propagationPolicy'] = requestParameters.propagationPolicy;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = '**';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/apis/apps/v1/namespaces/{namespace}/statefulsets/{name}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
            body: IoK8sApimachineryPkgApisMetaV1DeleteOptionsToJSON(requestParameters.body),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApimachineryPkgApisMetaV1StatusFromJSON(jsonValue));
    }
    /**
     * delete a StatefulSet
     */
    async deleteAppsV1NamespacedStatefulSet(requestParameters, initOverrides) {
        const response = await this.deleteAppsV1NamespacedStatefulSetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * get available resources
     */
    async getAppsV1APIResourcesRaw(initOverrides) {
        const queryParameters = {};
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/apis/apps/v1/`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApimachineryPkgApisMetaV1APIResourceListFromJSON(jsonValue));
    }
    /**
     * get available resources
     */
    async getAppsV1APIResources(initOverrides) {
        const response = await this.getAppsV1APIResourcesRaw(initOverrides);
        return await response.value();
    }
    /**
     * list or watch objects of kind ControllerRevision
     */
    async listAppsV1ControllerRevisionForAllNamespacesRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters.allowWatchBookmarks !== undefined) {
            queryParameters['allowWatchBookmarks'] = requestParameters.allowWatchBookmarks;
        }
        if (requestParameters._continue !== undefined) {
            queryParameters['continue'] = requestParameters._continue;
        }
        if (requestParameters.fieldSelector !== undefined) {
            queryParameters['fieldSelector'] = requestParameters.fieldSelector;
        }
        if (requestParameters.labelSelector !== undefined) {
            queryParameters['labelSelector'] = requestParameters.labelSelector;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.resourceVersion !== undefined) {
            queryParameters['resourceVersion'] = requestParameters.resourceVersion;
        }
        if (requestParameters.resourceVersionMatch !== undefined) {
            queryParameters['resourceVersionMatch'] = requestParameters.resourceVersionMatch;
        }
        if (requestParameters.timeoutSeconds !== undefined) {
            queryParameters['timeoutSeconds'] = requestParameters.timeoutSeconds;
        }
        if (requestParameters.watch !== undefined) {
            queryParameters['watch'] = requestParameters.watch;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/apis/apps/v1/controllerrevisions`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiAppsV1ControllerRevisionListFromJSON(jsonValue));
    }
    /**
     * list or watch objects of kind ControllerRevision
     */
    async listAppsV1ControllerRevisionForAllNamespaces(requestParameters = {}, initOverrides) {
        const response = await this.listAppsV1ControllerRevisionForAllNamespacesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * list or watch objects of kind DaemonSet
     */
    async listAppsV1DaemonSetForAllNamespacesRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters.allowWatchBookmarks !== undefined) {
            queryParameters['allowWatchBookmarks'] = requestParameters.allowWatchBookmarks;
        }
        if (requestParameters._continue !== undefined) {
            queryParameters['continue'] = requestParameters._continue;
        }
        if (requestParameters.fieldSelector !== undefined) {
            queryParameters['fieldSelector'] = requestParameters.fieldSelector;
        }
        if (requestParameters.labelSelector !== undefined) {
            queryParameters['labelSelector'] = requestParameters.labelSelector;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.resourceVersion !== undefined) {
            queryParameters['resourceVersion'] = requestParameters.resourceVersion;
        }
        if (requestParameters.resourceVersionMatch !== undefined) {
            queryParameters['resourceVersionMatch'] = requestParameters.resourceVersionMatch;
        }
        if (requestParameters.timeoutSeconds !== undefined) {
            queryParameters['timeoutSeconds'] = requestParameters.timeoutSeconds;
        }
        if (requestParameters.watch !== undefined) {
            queryParameters['watch'] = requestParameters.watch;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/apis/apps/v1/daemonsets`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiAppsV1DaemonSetListFromJSON(jsonValue));
    }
    /**
     * list or watch objects of kind DaemonSet
     */
    async listAppsV1DaemonSetForAllNamespaces(requestParameters = {}, initOverrides) {
        const response = await this.listAppsV1DaemonSetForAllNamespacesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * list or watch objects of kind Deployment
     */
    async listAppsV1DeploymentForAllNamespacesRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters.allowWatchBookmarks !== undefined) {
            queryParameters['allowWatchBookmarks'] = requestParameters.allowWatchBookmarks;
        }
        if (requestParameters._continue !== undefined) {
            queryParameters['continue'] = requestParameters._continue;
        }
        if (requestParameters.fieldSelector !== undefined) {
            queryParameters['fieldSelector'] = requestParameters.fieldSelector;
        }
        if (requestParameters.labelSelector !== undefined) {
            queryParameters['labelSelector'] = requestParameters.labelSelector;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.resourceVersion !== undefined) {
            queryParameters['resourceVersion'] = requestParameters.resourceVersion;
        }
        if (requestParameters.resourceVersionMatch !== undefined) {
            queryParameters['resourceVersionMatch'] = requestParameters.resourceVersionMatch;
        }
        if (requestParameters.timeoutSeconds !== undefined) {
            queryParameters['timeoutSeconds'] = requestParameters.timeoutSeconds;
        }
        if (requestParameters.watch !== undefined) {
            queryParameters['watch'] = requestParameters.watch;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/apis/apps/v1/deployments`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiAppsV1DeploymentListFromJSON(jsonValue));
    }
    /**
     * list or watch objects of kind Deployment
     */
    async listAppsV1DeploymentForAllNamespaces(requestParameters = {}, initOverrides) {
        const response = await this.listAppsV1DeploymentForAllNamespacesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * list or watch objects of kind ControllerRevision
     */
    async listAppsV1NamespacedControllerRevisionRaw(requestParameters, initOverrides) {
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling listAppsV1NamespacedControllerRevision.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.allowWatchBookmarks !== undefined) {
            queryParameters['allowWatchBookmarks'] = requestParameters.allowWatchBookmarks;
        }
        if (requestParameters._continue !== undefined) {
            queryParameters['continue'] = requestParameters._continue;
        }
        if (requestParameters.fieldSelector !== undefined) {
            queryParameters['fieldSelector'] = requestParameters.fieldSelector;
        }
        if (requestParameters.labelSelector !== undefined) {
            queryParameters['labelSelector'] = requestParameters.labelSelector;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.resourceVersion !== undefined) {
            queryParameters['resourceVersion'] = requestParameters.resourceVersion;
        }
        if (requestParameters.resourceVersionMatch !== undefined) {
            queryParameters['resourceVersionMatch'] = requestParameters.resourceVersionMatch;
        }
        if (requestParameters.timeoutSeconds !== undefined) {
            queryParameters['timeoutSeconds'] = requestParameters.timeoutSeconds;
        }
        if (requestParameters.watch !== undefined) {
            queryParameters['watch'] = requestParameters.watch;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/apis/apps/v1/namespaces/{namespace}/controllerrevisions`.replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiAppsV1ControllerRevisionListFromJSON(jsonValue));
    }
    /**
     * list or watch objects of kind ControllerRevision
     */
    async listAppsV1NamespacedControllerRevision(requestParameters, initOverrides) {
        const response = await this.listAppsV1NamespacedControllerRevisionRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * list or watch objects of kind DaemonSet
     */
    async listAppsV1NamespacedDaemonSetRaw(requestParameters, initOverrides) {
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling listAppsV1NamespacedDaemonSet.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.allowWatchBookmarks !== undefined) {
            queryParameters['allowWatchBookmarks'] = requestParameters.allowWatchBookmarks;
        }
        if (requestParameters._continue !== undefined) {
            queryParameters['continue'] = requestParameters._continue;
        }
        if (requestParameters.fieldSelector !== undefined) {
            queryParameters['fieldSelector'] = requestParameters.fieldSelector;
        }
        if (requestParameters.labelSelector !== undefined) {
            queryParameters['labelSelector'] = requestParameters.labelSelector;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.resourceVersion !== undefined) {
            queryParameters['resourceVersion'] = requestParameters.resourceVersion;
        }
        if (requestParameters.resourceVersionMatch !== undefined) {
            queryParameters['resourceVersionMatch'] = requestParameters.resourceVersionMatch;
        }
        if (requestParameters.timeoutSeconds !== undefined) {
            queryParameters['timeoutSeconds'] = requestParameters.timeoutSeconds;
        }
        if (requestParameters.watch !== undefined) {
            queryParameters['watch'] = requestParameters.watch;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/apis/apps/v1/namespaces/{namespace}/daemonsets`.replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiAppsV1DaemonSetListFromJSON(jsonValue));
    }
    /**
     * list or watch objects of kind DaemonSet
     */
    async listAppsV1NamespacedDaemonSet(requestParameters, initOverrides) {
        const response = await this.listAppsV1NamespacedDaemonSetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * list or watch objects of kind Deployment
     */
    async listAppsV1NamespacedDeploymentRaw(requestParameters, initOverrides) {
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling listAppsV1NamespacedDeployment.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.allowWatchBookmarks !== undefined) {
            queryParameters['allowWatchBookmarks'] = requestParameters.allowWatchBookmarks;
        }
        if (requestParameters._continue !== undefined) {
            queryParameters['continue'] = requestParameters._continue;
        }
        if (requestParameters.fieldSelector !== undefined) {
            queryParameters['fieldSelector'] = requestParameters.fieldSelector;
        }
        if (requestParameters.labelSelector !== undefined) {
            queryParameters['labelSelector'] = requestParameters.labelSelector;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.resourceVersion !== undefined) {
            queryParameters['resourceVersion'] = requestParameters.resourceVersion;
        }
        if (requestParameters.resourceVersionMatch !== undefined) {
            queryParameters['resourceVersionMatch'] = requestParameters.resourceVersionMatch;
        }
        if (requestParameters.timeoutSeconds !== undefined) {
            queryParameters['timeoutSeconds'] = requestParameters.timeoutSeconds;
        }
        if (requestParameters.watch !== undefined) {
            queryParameters['watch'] = requestParameters.watch;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/apis/apps/v1/namespaces/{namespace}/deployments`.replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiAppsV1DeploymentListFromJSON(jsonValue));
    }
    /**
     * list or watch objects of kind Deployment
     */
    async listAppsV1NamespacedDeployment(requestParameters, initOverrides) {
        const response = await this.listAppsV1NamespacedDeploymentRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * list or watch objects of kind ReplicaSet
     */
    async listAppsV1NamespacedReplicaSetRaw(requestParameters, initOverrides) {
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling listAppsV1NamespacedReplicaSet.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.allowWatchBookmarks !== undefined) {
            queryParameters['allowWatchBookmarks'] = requestParameters.allowWatchBookmarks;
        }
        if (requestParameters._continue !== undefined) {
            queryParameters['continue'] = requestParameters._continue;
        }
        if (requestParameters.fieldSelector !== undefined) {
            queryParameters['fieldSelector'] = requestParameters.fieldSelector;
        }
        if (requestParameters.labelSelector !== undefined) {
            queryParameters['labelSelector'] = requestParameters.labelSelector;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.resourceVersion !== undefined) {
            queryParameters['resourceVersion'] = requestParameters.resourceVersion;
        }
        if (requestParameters.resourceVersionMatch !== undefined) {
            queryParameters['resourceVersionMatch'] = requestParameters.resourceVersionMatch;
        }
        if (requestParameters.timeoutSeconds !== undefined) {
            queryParameters['timeoutSeconds'] = requestParameters.timeoutSeconds;
        }
        if (requestParameters.watch !== undefined) {
            queryParameters['watch'] = requestParameters.watch;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/apis/apps/v1/namespaces/{namespace}/replicasets`.replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiAppsV1ReplicaSetListFromJSON(jsonValue));
    }
    /**
     * list or watch objects of kind ReplicaSet
     */
    async listAppsV1NamespacedReplicaSet(requestParameters, initOverrides) {
        const response = await this.listAppsV1NamespacedReplicaSetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * list or watch objects of kind StatefulSet
     */
    async listAppsV1NamespacedStatefulSetRaw(requestParameters, initOverrides) {
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling listAppsV1NamespacedStatefulSet.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.allowWatchBookmarks !== undefined) {
            queryParameters['allowWatchBookmarks'] = requestParameters.allowWatchBookmarks;
        }
        if (requestParameters._continue !== undefined) {
            queryParameters['continue'] = requestParameters._continue;
        }
        if (requestParameters.fieldSelector !== undefined) {
            queryParameters['fieldSelector'] = requestParameters.fieldSelector;
        }
        if (requestParameters.labelSelector !== undefined) {
            queryParameters['labelSelector'] = requestParameters.labelSelector;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.resourceVersion !== undefined) {
            queryParameters['resourceVersion'] = requestParameters.resourceVersion;
        }
        if (requestParameters.resourceVersionMatch !== undefined) {
            queryParameters['resourceVersionMatch'] = requestParameters.resourceVersionMatch;
        }
        if (requestParameters.timeoutSeconds !== undefined) {
            queryParameters['timeoutSeconds'] = requestParameters.timeoutSeconds;
        }
        if (requestParameters.watch !== undefined) {
            queryParameters['watch'] = requestParameters.watch;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/apis/apps/v1/namespaces/{namespace}/statefulsets`.replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiAppsV1StatefulSetListFromJSON(jsonValue));
    }
    /**
     * list or watch objects of kind StatefulSet
     */
    async listAppsV1NamespacedStatefulSet(requestParameters, initOverrides) {
        const response = await this.listAppsV1NamespacedStatefulSetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * list or watch objects of kind ReplicaSet
     */
    async listAppsV1ReplicaSetForAllNamespacesRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters.allowWatchBookmarks !== undefined) {
            queryParameters['allowWatchBookmarks'] = requestParameters.allowWatchBookmarks;
        }
        if (requestParameters._continue !== undefined) {
            queryParameters['continue'] = requestParameters._continue;
        }
        if (requestParameters.fieldSelector !== undefined) {
            queryParameters['fieldSelector'] = requestParameters.fieldSelector;
        }
        if (requestParameters.labelSelector !== undefined) {
            queryParameters['labelSelector'] = requestParameters.labelSelector;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.resourceVersion !== undefined) {
            queryParameters['resourceVersion'] = requestParameters.resourceVersion;
        }
        if (requestParameters.resourceVersionMatch !== undefined) {
            queryParameters['resourceVersionMatch'] = requestParameters.resourceVersionMatch;
        }
        if (requestParameters.timeoutSeconds !== undefined) {
            queryParameters['timeoutSeconds'] = requestParameters.timeoutSeconds;
        }
        if (requestParameters.watch !== undefined) {
            queryParameters['watch'] = requestParameters.watch;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/apis/apps/v1/replicasets`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiAppsV1ReplicaSetListFromJSON(jsonValue));
    }
    /**
     * list or watch objects of kind ReplicaSet
     */
    async listAppsV1ReplicaSetForAllNamespaces(requestParameters = {}, initOverrides) {
        const response = await this.listAppsV1ReplicaSetForAllNamespacesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * list or watch objects of kind StatefulSet
     */
    async listAppsV1StatefulSetForAllNamespacesRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters.allowWatchBookmarks !== undefined) {
            queryParameters['allowWatchBookmarks'] = requestParameters.allowWatchBookmarks;
        }
        if (requestParameters._continue !== undefined) {
            queryParameters['continue'] = requestParameters._continue;
        }
        if (requestParameters.fieldSelector !== undefined) {
            queryParameters['fieldSelector'] = requestParameters.fieldSelector;
        }
        if (requestParameters.labelSelector !== undefined) {
            queryParameters['labelSelector'] = requestParameters.labelSelector;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.resourceVersion !== undefined) {
            queryParameters['resourceVersion'] = requestParameters.resourceVersion;
        }
        if (requestParameters.resourceVersionMatch !== undefined) {
            queryParameters['resourceVersionMatch'] = requestParameters.resourceVersionMatch;
        }
        if (requestParameters.timeoutSeconds !== undefined) {
            queryParameters['timeoutSeconds'] = requestParameters.timeoutSeconds;
        }
        if (requestParameters.watch !== undefined) {
            queryParameters['watch'] = requestParameters.watch;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/apis/apps/v1/statefulsets`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiAppsV1StatefulSetListFromJSON(jsonValue));
    }
    /**
     * list or watch objects of kind StatefulSet
     */
    async listAppsV1StatefulSetForAllNamespaces(requestParameters = {}, initOverrides) {
        const response = await this.listAppsV1StatefulSetForAllNamespacesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * partially update the specified ControllerRevision
     */
    async patchAppsV1NamespacedControllerRevisionRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling patchAppsV1NamespacedControllerRevision.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling patchAppsV1NamespacedControllerRevision.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling patchAppsV1NamespacedControllerRevision.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.dryRun !== undefined) {
            queryParameters['dryRun'] = requestParameters.dryRun;
        }
        if (requestParameters.fieldManager !== undefined) {
            queryParameters['fieldManager'] = requestParameters.fieldManager;
        }
        if (requestParameters.fieldValidation !== undefined) {
            queryParameters['fieldValidation'] = requestParameters.fieldValidation;
        }
        if (requestParameters.force !== undefined) {
            queryParameters['force'] = requestParameters.force;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json-patch+json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/apis/apps/v1/namespaces/{namespace}/controllerrevisions/{name}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiAppsV1ControllerRevisionFromJSON(jsonValue));
    }
    /**
     * partially update the specified ControllerRevision
     */
    async patchAppsV1NamespacedControllerRevision(requestParameters, initOverrides) {
        const response = await this.patchAppsV1NamespacedControllerRevisionRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * partially update the specified DaemonSet
     */
    async patchAppsV1NamespacedDaemonSetRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling patchAppsV1NamespacedDaemonSet.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling patchAppsV1NamespacedDaemonSet.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling patchAppsV1NamespacedDaemonSet.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.dryRun !== undefined) {
            queryParameters['dryRun'] = requestParameters.dryRun;
        }
        if (requestParameters.fieldManager !== undefined) {
            queryParameters['fieldManager'] = requestParameters.fieldManager;
        }
        if (requestParameters.fieldValidation !== undefined) {
            queryParameters['fieldValidation'] = requestParameters.fieldValidation;
        }
        if (requestParameters.force !== undefined) {
            queryParameters['force'] = requestParameters.force;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json-patch+json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/apis/apps/v1/namespaces/{namespace}/daemonsets/{name}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiAppsV1DaemonSetFromJSON(jsonValue));
    }
    /**
     * partially update the specified DaemonSet
     */
    async patchAppsV1NamespacedDaemonSet(requestParameters, initOverrides) {
        const response = await this.patchAppsV1NamespacedDaemonSetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * partially update status of the specified DaemonSet
     */
    async patchAppsV1NamespacedDaemonSetStatusRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling patchAppsV1NamespacedDaemonSetStatus.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling patchAppsV1NamespacedDaemonSetStatus.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling patchAppsV1NamespacedDaemonSetStatus.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.dryRun !== undefined) {
            queryParameters['dryRun'] = requestParameters.dryRun;
        }
        if (requestParameters.fieldManager !== undefined) {
            queryParameters['fieldManager'] = requestParameters.fieldManager;
        }
        if (requestParameters.fieldValidation !== undefined) {
            queryParameters['fieldValidation'] = requestParameters.fieldValidation;
        }
        if (requestParameters.force !== undefined) {
            queryParameters['force'] = requestParameters.force;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json-patch+json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/apis/apps/v1/namespaces/{namespace}/daemonsets/{name}/status`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiAppsV1DaemonSetFromJSON(jsonValue));
    }
    /**
     * partially update status of the specified DaemonSet
     */
    async patchAppsV1NamespacedDaemonSetStatus(requestParameters, initOverrides) {
        const response = await this.patchAppsV1NamespacedDaemonSetStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * partially update the specified Deployment
     */
    async patchAppsV1NamespacedDeploymentRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling patchAppsV1NamespacedDeployment.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling patchAppsV1NamespacedDeployment.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling patchAppsV1NamespacedDeployment.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.dryRun !== undefined) {
            queryParameters['dryRun'] = requestParameters.dryRun;
        }
        if (requestParameters.fieldManager !== undefined) {
            queryParameters['fieldManager'] = requestParameters.fieldManager;
        }
        if (requestParameters.fieldValidation !== undefined) {
            queryParameters['fieldValidation'] = requestParameters.fieldValidation;
        }
        if (requestParameters.force !== undefined) {
            queryParameters['force'] = requestParameters.force;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json-patch+json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/apis/apps/v1/namespaces/{namespace}/deployments/{name}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiAppsV1DeploymentFromJSON(jsonValue));
    }
    /**
     * partially update the specified Deployment
     */
    async patchAppsV1NamespacedDeployment(requestParameters, initOverrides) {
        const response = await this.patchAppsV1NamespacedDeploymentRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * partially update scale of the specified Deployment
     */
    async patchAppsV1NamespacedDeploymentScaleRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling patchAppsV1NamespacedDeploymentScale.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling patchAppsV1NamespacedDeploymentScale.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling patchAppsV1NamespacedDeploymentScale.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.dryRun !== undefined) {
            queryParameters['dryRun'] = requestParameters.dryRun;
        }
        if (requestParameters.fieldManager !== undefined) {
            queryParameters['fieldManager'] = requestParameters.fieldManager;
        }
        if (requestParameters.fieldValidation !== undefined) {
            queryParameters['fieldValidation'] = requestParameters.fieldValidation;
        }
        if (requestParameters.force !== undefined) {
            queryParameters['force'] = requestParameters.force;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json-patch+json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/apis/apps/v1/namespaces/{namespace}/deployments/{name}/scale`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiAutoscalingV1ScaleFromJSON(jsonValue));
    }
    /**
     * partially update scale of the specified Deployment
     */
    async patchAppsV1NamespacedDeploymentScale(requestParameters, initOverrides) {
        const response = await this.patchAppsV1NamespacedDeploymentScaleRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * partially update status of the specified Deployment
     */
    async patchAppsV1NamespacedDeploymentStatusRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling patchAppsV1NamespacedDeploymentStatus.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling patchAppsV1NamespacedDeploymentStatus.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling patchAppsV1NamespacedDeploymentStatus.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.dryRun !== undefined) {
            queryParameters['dryRun'] = requestParameters.dryRun;
        }
        if (requestParameters.fieldManager !== undefined) {
            queryParameters['fieldManager'] = requestParameters.fieldManager;
        }
        if (requestParameters.fieldValidation !== undefined) {
            queryParameters['fieldValidation'] = requestParameters.fieldValidation;
        }
        if (requestParameters.force !== undefined) {
            queryParameters['force'] = requestParameters.force;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json-patch+json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/apis/apps/v1/namespaces/{namespace}/deployments/{name}/status`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiAppsV1DeploymentFromJSON(jsonValue));
    }
    /**
     * partially update status of the specified Deployment
     */
    async patchAppsV1NamespacedDeploymentStatus(requestParameters, initOverrides) {
        const response = await this.patchAppsV1NamespacedDeploymentStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * partially update the specified ReplicaSet
     */
    async patchAppsV1NamespacedReplicaSetRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling patchAppsV1NamespacedReplicaSet.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling patchAppsV1NamespacedReplicaSet.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling patchAppsV1NamespacedReplicaSet.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.dryRun !== undefined) {
            queryParameters['dryRun'] = requestParameters.dryRun;
        }
        if (requestParameters.fieldManager !== undefined) {
            queryParameters['fieldManager'] = requestParameters.fieldManager;
        }
        if (requestParameters.fieldValidation !== undefined) {
            queryParameters['fieldValidation'] = requestParameters.fieldValidation;
        }
        if (requestParameters.force !== undefined) {
            queryParameters['force'] = requestParameters.force;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json-patch+json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/apis/apps/v1/namespaces/{namespace}/replicasets/{name}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiAppsV1ReplicaSetFromJSON(jsonValue));
    }
    /**
     * partially update the specified ReplicaSet
     */
    async patchAppsV1NamespacedReplicaSet(requestParameters, initOverrides) {
        const response = await this.patchAppsV1NamespacedReplicaSetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * partially update scale of the specified ReplicaSet
     */
    async patchAppsV1NamespacedReplicaSetScaleRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling patchAppsV1NamespacedReplicaSetScale.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling patchAppsV1NamespacedReplicaSetScale.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling patchAppsV1NamespacedReplicaSetScale.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.dryRun !== undefined) {
            queryParameters['dryRun'] = requestParameters.dryRun;
        }
        if (requestParameters.fieldManager !== undefined) {
            queryParameters['fieldManager'] = requestParameters.fieldManager;
        }
        if (requestParameters.fieldValidation !== undefined) {
            queryParameters['fieldValidation'] = requestParameters.fieldValidation;
        }
        if (requestParameters.force !== undefined) {
            queryParameters['force'] = requestParameters.force;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json-patch+json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/apis/apps/v1/namespaces/{namespace}/replicasets/{name}/scale`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiAutoscalingV1ScaleFromJSON(jsonValue));
    }
    /**
     * partially update scale of the specified ReplicaSet
     */
    async patchAppsV1NamespacedReplicaSetScale(requestParameters, initOverrides) {
        const response = await this.patchAppsV1NamespacedReplicaSetScaleRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * partially update status of the specified ReplicaSet
     */
    async patchAppsV1NamespacedReplicaSetStatusRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling patchAppsV1NamespacedReplicaSetStatus.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling patchAppsV1NamespacedReplicaSetStatus.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling patchAppsV1NamespacedReplicaSetStatus.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.dryRun !== undefined) {
            queryParameters['dryRun'] = requestParameters.dryRun;
        }
        if (requestParameters.fieldManager !== undefined) {
            queryParameters['fieldManager'] = requestParameters.fieldManager;
        }
        if (requestParameters.fieldValidation !== undefined) {
            queryParameters['fieldValidation'] = requestParameters.fieldValidation;
        }
        if (requestParameters.force !== undefined) {
            queryParameters['force'] = requestParameters.force;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json-patch+json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/apis/apps/v1/namespaces/{namespace}/replicasets/{name}/status`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiAppsV1ReplicaSetFromJSON(jsonValue));
    }
    /**
     * partially update status of the specified ReplicaSet
     */
    async patchAppsV1NamespacedReplicaSetStatus(requestParameters, initOverrides) {
        const response = await this.patchAppsV1NamespacedReplicaSetStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * partially update the specified StatefulSet
     */
    async patchAppsV1NamespacedStatefulSetRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling patchAppsV1NamespacedStatefulSet.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling patchAppsV1NamespacedStatefulSet.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling patchAppsV1NamespacedStatefulSet.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.dryRun !== undefined) {
            queryParameters['dryRun'] = requestParameters.dryRun;
        }
        if (requestParameters.fieldManager !== undefined) {
            queryParameters['fieldManager'] = requestParameters.fieldManager;
        }
        if (requestParameters.fieldValidation !== undefined) {
            queryParameters['fieldValidation'] = requestParameters.fieldValidation;
        }
        if (requestParameters.force !== undefined) {
            queryParameters['force'] = requestParameters.force;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json-patch+json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/apis/apps/v1/namespaces/{namespace}/statefulsets/{name}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiAppsV1StatefulSetFromJSON(jsonValue));
    }
    /**
     * partially update the specified StatefulSet
     */
    async patchAppsV1NamespacedStatefulSet(requestParameters, initOverrides) {
        const response = await this.patchAppsV1NamespacedStatefulSetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * partially update scale of the specified StatefulSet
     */
    async patchAppsV1NamespacedStatefulSetScaleRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling patchAppsV1NamespacedStatefulSetScale.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling patchAppsV1NamespacedStatefulSetScale.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling patchAppsV1NamespacedStatefulSetScale.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.dryRun !== undefined) {
            queryParameters['dryRun'] = requestParameters.dryRun;
        }
        if (requestParameters.fieldManager !== undefined) {
            queryParameters['fieldManager'] = requestParameters.fieldManager;
        }
        if (requestParameters.fieldValidation !== undefined) {
            queryParameters['fieldValidation'] = requestParameters.fieldValidation;
        }
        if (requestParameters.force !== undefined) {
            queryParameters['force'] = requestParameters.force;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json-patch+json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/apis/apps/v1/namespaces/{namespace}/statefulsets/{name}/scale`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiAutoscalingV1ScaleFromJSON(jsonValue));
    }
    /**
     * partially update scale of the specified StatefulSet
     */
    async patchAppsV1NamespacedStatefulSetScale(requestParameters, initOverrides) {
        const response = await this.patchAppsV1NamespacedStatefulSetScaleRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * partially update status of the specified StatefulSet
     */
    async patchAppsV1NamespacedStatefulSetStatusRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling patchAppsV1NamespacedStatefulSetStatus.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling patchAppsV1NamespacedStatefulSetStatus.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling patchAppsV1NamespacedStatefulSetStatus.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.dryRun !== undefined) {
            queryParameters['dryRun'] = requestParameters.dryRun;
        }
        if (requestParameters.fieldManager !== undefined) {
            queryParameters['fieldManager'] = requestParameters.fieldManager;
        }
        if (requestParameters.fieldValidation !== undefined) {
            queryParameters['fieldValidation'] = requestParameters.fieldValidation;
        }
        if (requestParameters.force !== undefined) {
            queryParameters['force'] = requestParameters.force;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = 'application/json-patch+json';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/apis/apps/v1/namespaces/{namespace}/statefulsets/{name}/status`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters.body,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiAppsV1StatefulSetFromJSON(jsonValue));
    }
    /**
     * partially update status of the specified StatefulSet
     */
    async patchAppsV1NamespacedStatefulSetStatus(requestParameters, initOverrides) {
        const response = await this.patchAppsV1NamespacedStatefulSetStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * read the specified ControllerRevision
     */
    async readAppsV1NamespacedControllerRevisionRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling readAppsV1NamespacedControllerRevision.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling readAppsV1NamespacedControllerRevision.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/apis/apps/v1/namespaces/{namespace}/controllerrevisions/{name}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiAppsV1ControllerRevisionFromJSON(jsonValue));
    }
    /**
     * read the specified ControllerRevision
     */
    async readAppsV1NamespacedControllerRevision(requestParameters, initOverrides) {
        const response = await this.readAppsV1NamespacedControllerRevisionRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * read the specified DaemonSet
     */
    async readAppsV1NamespacedDaemonSetRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling readAppsV1NamespacedDaemonSet.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling readAppsV1NamespacedDaemonSet.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/apis/apps/v1/namespaces/{namespace}/daemonsets/{name}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiAppsV1DaemonSetFromJSON(jsonValue));
    }
    /**
     * read the specified DaemonSet
     */
    async readAppsV1NamespacedDaemonSet(requestParameters, initOverrides) {
        const response = await this.readAppsV1NamespacedDaemonSetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * read status of the specified DaemonSet
     */
    async readAppsV1NamespacedDaemonSetStatusRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling readAppsV1NamespacedDaemonSetStatus.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling readAppsV1NamespacedDaemonSetStatus.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/apis/apps/v1/namespaces/{namespace}/daemonsets/{name}/status`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiAppsV1DaemonSetFromJSON(jsonValue));
    }
    /**
     * read status of the specified DaemonSet
     */
    async readAppsV1NamespacedDaemonSetStatus(requestParameters, initOverrides) {
        const response = await this.readAppsV1NamespacedDaemonSetStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * read the specified Deployment
     */
    async readAppsV1NamespacedDeploymentRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling readAppsV1NamespacedDeployment.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling readAppsV1NamespacedDeployment.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/apis/apps/v1/namespaces/{namespace}/deployments/{name}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiAppsV1DeploymentFromJSON(jsonValue));
    }
    /**
     * read the specified Deployment
     */
    async readAppsV1NamespacedDeployment(requestParameters, initOverrides) {
        const response = await this.readAppsV1NamespacedDeploymentRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * read scale of the specified Deployment
     */
    async readAppsV1NamespacedDeploymentScaleRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling readAppsV1NamespacedDeploymentScale.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling readAppsV1NamespacedDeploymentScale.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/apis/apps/v1/namespaces/{namespace}/deployments/{name}/scale`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiAutoscalingV1ScaleFromJSON(jsonValue));
    }
    /**
     * read scale of the specified Deployment
     */
    async readAppsV1NamespacedDeploymentScale(requestParameters, initOverrides) {
        const response = await this.readAppsV1NamespacedDeploymentScaleRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * read status of the specified Deployment
     */
    async readAppsV1NamespacedDeploymentStatusRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling readAppsV1NamespacedDeploymentStatus.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling readAppsV1NamespacedDeploymentStatus.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/apis/apps/v1/namespaces/{namespace}/deployments/{name}/status`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiAppsV1DeploymentFromJSON(jsonValue));
    }
    /**
     * read status of the specified Deployment
     */
    async readAppsV1NamespacedDeploymentStatus(requestParameters, initOverrides) {
        const response = await this.readAppsV1NamespacedDeploymentStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * read the specified ReplicaSet
     */
    async readAppsV1NamespacedReplicaSetRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling readAppsV1NamespacedReplicaSet.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling readAppsV1NamespacedReplicaSet.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/apis/apps/v1/namespaces/{namespace}/replicasets/{name}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiAppsV1ReplicaSetFromJSON(jsonValue));
    }
    /**
     * read the specified ReplicaSet
     */
    async readAppsV1NamespacedReplicaSet(requestParameters, initOverrides) {
        const response = await this.readAppsV1NamespacedReplicaSetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * read scale of the specified ReplicaSet
     */
    async readAppsV1NamespacedReplicaSetScaleRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling readAppsV1NamespacedReplicaSetScale.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling readAppsV1NamespacedReplicaSetScale.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/apis/apps/v1/namespaces/{namespace}/replicasets/{name}/scale`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiAutoscalingV1ScaleFromJSON(jsonValue));
    }
    /**
     * read scale of the specified ReplicaSet
     */
    async readAppsV1NamespacedReplicaSetScale(requestParameters, initOverrides) {
        const response = await this.readAppsV1NamespacedReplicaSetScaleRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * read status of the specified ReplicaSet
     */
    async readAppsV1NamespacedReplicaSetStatusRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling readAppsV1NamespacedReplicaSetStatus.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling readAppsV1NamespacedReplicaSetStatus.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/apis/apps/v1/namespaces/{namespace}/replicasets/{name}/status`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiAppsV1ReplicaSetFromJSON(jsonValue));
    }
    /**
     * read status of the specified ReplicaSet
     */
    async readAppsV1NamespacedReplicaSetStatus(requestParameters, initOverrides) {
        const response = await this.readAppsV1NamespacedReplicaSetStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * read the specified StatefulSet
     */
    async readAppsV1NamespacedStatefulSetRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling readAppsV1NamespacedStatefulSet.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling readAppsV1NamespacedStatefulSet.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/apis/apps/v1/namespaces/{namespace}/statefulsets/{name}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiAppsV1StatefulSetFromJSON(jsonValue));
    }
    /**
     * read the specified StatefulSet
     */
    async readAppsV1NamespacedStatefulSet(requestParameters, initOverrides) {
        const response = await this.readAppsV1NamespacedStatefulSetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * read scale of the specified StatefulSet
     */
    async readAppsV1NamespacedStatefulSetScaleRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling readAppsV1NamespacedStatefulSetScale.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling readAppsV1NamespacedStatefulSetScale.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/apis/apps/v1/namespaces/{namespace}/statefulsets/{name}/scale`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiAutoscalingV1ScaleFromJSON(jsonValue));
    }
    /**
     * read scale of the specified StatefulSet
     */
    async readAppsV1NamespacedStatefulSetScale(requestParameters, initOverrides) {
        const response = await this.readAppsV1NamespacedStatefulSetScaleRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * read status of the specified StatefulSet
     */
    async readAppsV1NamespacedStatefulSetStatusRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling readAppsV1NamespacedStatefulSetStatus.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling readAppsV1NamespacedStatefulSetStatus.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/apis/apps/v1/namespaces/{namespace}/statefulsets/{name}/status`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiAppsV1StatefulSetFromJSON(jsonValue));
    }
    /**
     * read status of the specified StatefulSet
     */
    async readAppsV1NamespacedStatefulSetStatus(requestParameters, initOverrides) {
        const response = await this.readAppsV1NamespacedStatefulSetStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * replace the specified ControllerRevision
     */
    async replaceAppsV1NamespacedControllerRevisionRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling replaceAppsV1NamespacedControllerRevision.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling replaceAppsV1NamespacedControllerRevision.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling replaceAppsV1NamespacedControllerRevision.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.dryRun !== undefined) {
            queryParameters['dryRun'] = requestParameters.dryRun;
        }
        if (requestParameters.fieldManager !== undefined) {
            queryParameters['fieldManager'] = requestParameters.fieldManager;
        }
        if (requestParameters.fieldValidation !== undefined) {
            queryParameters['fieldValidation'] = requestParameters.fieldValidation;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = '**';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/apis/apps/v1/namespaces/{namespace}/controllerrevisions/{name}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: IoK8sApiAppsV1ControllerRevisionToJSON(requestParameters.body),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiAppsV1ControllerRevisionFromJSON(jsonValue));
    }
    /**
     * replace the specified ControllerRevision
     */
    async replaceAppsV1NamespacedControllerRevision(requestParameters, initOverrides) {
        const response = await this.replaceAppsV1NamespacedControllerRevisionRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * replace the specified DaemonSet
     */
    async replaceAppsV1NamespacedDaemonSetRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling replaceAppsV1NamespacedDaemonSet.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling replaceAppsV1NamespacedDaemonSet.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling replaceAppsV1NamespacedDaemonSet.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.dryRun !== undefined) {
            queryParameters['dryRun'] = requestParameters.dryRun;
        }
        if (requestParameters.fieldManager !== undefined) {
            queryParameters['fieldManager'] = requestParameters.fieldManager;
        }
        if (requestParameters.fieldValidation !== undefined) {
            queryParameters['fieldValidation'] = requestParameters.fieldValidation;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = '**';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/apis/apps/v1/namespaces/{namespace}/daemonsets/{name}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: IoK8sApiAppsV1DaemonSetToJSON(requestParameters.body),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiAppsV1DaemonSetFromJSON(jsonValue));
    }
    /**
     * replace the specified DaemonSet
     */
    async replaceAppsV1NamespacedDaemonSet(requestParameters, initOverrides) {
        const response = await this.replaceAppsV1NamespacedDaemonSetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * replace status of the specified DaemonSet
     */
    async replaceAppsV1NamespacedDaemonSetStatusRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling replaceAppsV1NamespacedDaemonSetStatus.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling replaceAppsV1NamespacedDaemonSetStatus.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling replaceAppsV1NamespacedDaemonSetStatus.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.dryRun !== undefined) {
            queryParameters['dryRun'] = requestParameters.dryRun;
        }
        if (requestParameters.fieldManager !== undefined) {
            queryParameters['fieldManager'] = requestParameters.fieldManager;
        }
        if (requestParameters.fieldValidation !== undefined) {
            queryParameters['fieldValidation'] = requestParameters.fieldValidation;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = '**';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/apis/apps/v1/namespaces/{namespace}/daemonsets/{name}/status`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: IoK8sApiAppsV1DaemonSetToJSON(requestParameters.body),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiAppsV1DaemonSetFromJSON(jsonValue));
    }
    /**
     * replace status of the specified DaemonSet
     */
    async replaceAppsV1NamespacedDaemonSetStatus(requestParameters, initOverrides) {
        const response = await this.replaceAppsV1NamespacedDaemonSetStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * replace the specified Deployment
     */
    async replaceAppsV1NamespacedDeploymentRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling replaceAppsV1NamespacedDeployment.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling replaceAppsV1NamespacedDeployment.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling replaceAppsV1NamespacedDeployment.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.dryRun !== undefined) {
            queryParameters['dryRun'] = requestParameters.dryRun;
        }
        if (requestParameters.fieldManager !== undefined) {
            queryParameters['fieldManager'] = requestParameters.fieldManager;
        }
        if (requestParameters.fieldValidation !== undefined) {
            queryParameters['fieldValidation'] = requestParameters.fieldValidation;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = '**';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/apis/apps/v1/namespaces/{namespace}/deployments/{name}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: IoK8sApiAppsV1DeploymentToJSON(requestParameters.body),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiAppsV1DeploymentFromJSON(jsonValue));
    }
    /**
     * replace the specified Deployment
     */
    async replaceAppsV1NamespacedDeployment(requestParameters, initOverrides) {
        const response = await this.replaceAppsV1NamespacedDeploymentRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * replace scale of the specified Deployment
     */
    async replaceAppsV1NamespacedDeploymentScaleRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling replaceAppsV1NamespacedDeploymentScale.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling replaceAppsV1NamespacedDeploymentScale.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling replaceAppsV1NamespacedDeploymentScale.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.dryRun !== undefined) {
            queryParameters['dryRun'] = requestParameters.dryRun;
        }
        if (requestParameters.fieldManager !== undefined) {
            queryParameters['fieldManager'] = requestParameters.fieldManager;
        }
        if (requestParameters.fieldValidation !== undefined) {
            queryParameters['fieldValidation'] = requestParameters.fieldValidation;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = '**';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/apis/apps/v1/namespaces/{namespace}/deployments/{name}/scale`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: IoK8sApiAutoscalingV1ScaleToJSON(requestParameters.body),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiAutoscalingV1ScaleFromJSON(jsonValue));
    }
    /**
     * replace scale of the specified Deployment
     */
    async replaceAppsV1NamespacedDeploymentScale(requestParameters, initOverrides) {
        const response = await this.replaceAppsV1NamespacedDeploymentScaleRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * replace status of the specified Deployment
     */
    async replaceAppsV1NamespacedDeploymentStatusRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling replaceAppsV1NamespacedDeploymentStatus.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling replaceAppsV1NamespacedDeploymentStatus.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling replaceAppsV1NamespacedDeploymentStatus.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.dryRun !== undefined) {
            queryParameters['dryRun'] = requestParameters.dryRun;
        }
        if (requestParameters.fieldManager !== undefined) {
            queryParameters['fieldManager'] = requestParameters.fieldManager;
        }
        if (requestParameters.fieldValidation !== undefined) {
            queryParameters['fieldValidation'] = requestParameters.fieldValidation;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = '**';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/apis/apps/v1/namespaces/{namespace}/deployments/{name}/status`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: IoK8sApiAppsV1DeploymentToJSON(requestParameters.body),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiAppsV1DeploymentFromJSON(jsonValue));
    }
    /**
     * replace status of the specified Deployment
     */
    async replaceAppsV1NamespacedDeploymentStatus(requestParameters, initOverrides) {
        const response = await this.replaceAppsV1NamespacedDeploymentStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * replace the specified ReplicaSet
     */
    async replaceAppsV1NamespacedReplicaSetRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling replaceAppsV1NamespacedReplicaSet.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling replaceAppsV1NamespacedReplicaSet.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling replaceAppsV1NamespacedReplicaSet.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.dryRun !== undefined) {
            queryParameters['dryRun'] = requestParameters.dryRun;
        }
        if (requestParameters.fieldManager !== undefined) {
            queryParameters['fieldManager'] = requestParameters.fieldManager;
        }
        if (requestParameters.fieldValidation !== undefined) {
            queryParameters['fieldValidation'] = requestParameters.fieldValidation;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = '**';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/apis/apps/v1/namespaces/{namespace}/replicasets/{name}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: IoK8sApiAppsV1ReplicaSetToJSON(requestParameters.body),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiAppsV1ReplicaSetFromJSON(jsonValue));
    }
    /**
     * replace the specified ReplicaSet
     */
    async replaceAppsV1NamespacedReplicaSet(requestParameters, initOverrides) {
        const response = await this.replaceAppsV1NamespacedReplicaSetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * replace scale of the specified ReplicaSet
     */
    async replaceAppsV1NamespacedReplicaSetScaleRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling replaceAppsV1NamespacedReplicaSetScale.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling replaceAppsV1NamespacedReplicaSetScale.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling replaceAppsV1NamespacedReplicaSetScale.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.dryRun !== undefined) {
            queryParameters['dryRun'] = requestParameters.dryRun;
        }
        if (requestParameters.fieldManager !== undefined) {
            queryParameters['fieldManager'] = requestParameters.fieldManager;
        }
        if (requestParameters.fieldValidation !== undefined) {
            queryParameters['fieldValidation'] = requestParameters.fieldValidation;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = '**';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/apis/apps/v1/namespaces/{namespace}/replicasets/{name}/scale`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: IoK8sApiAutoscalingV1ScaleToJSON(requestParameters.body),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiAutoscalingV1ScaleFromJSON(jsonValue));
    }
    /**
     * replace scale of the specified ReplicaSet
     */
    async replaceAppsV1NamespacedReplicaSetScale(requestParameters, initOverrides) {
        const response = await this.replaceAppsV1NamespacedReplicaSetScaleRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * replace status of the specified ReplicaSet
     */
    async replaceAppsV1NamespacedReplicaSetStatusRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling replaceAppsV1NamespacedReplicaSetStatus.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling replaceAppsV1NamespacedReplicaSetStatus.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling replaceAppsV1NamespacedReplicaSetStatus.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.dryRun !== undefined) {
            queryParameters['dryRun'] = requestParameters.dryRun;
        }
        if (requestParameters.fieldManager !== undefined) {
            queryParameters['fieldManager'] = requestParameters.fieldManager;
        }
        if (requestParameters.fieldValidation !== undefined) {
            queryParameters['fieldValidation'] = requestParameters.fieldValidation;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = '**';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/apis/apps/v1/namespaces/{namespace}/replicasets/{name}/status`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: IoK8sApiAppsV1ReplicaSetToJSON(requestParameters.body),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiAppsV1ReplicaSetFromJSON(jsonValue));
    }
    /**
     * replace status of the specified ReplicaSet
     */
    async replaceAppsV1NamespacedReplicaSetStatus(requestParameters, initOverrides) {
        const response = await this.replaceAppsV1NamespacedReplicaSetStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * replace the specified StatefulSet
     */
    async replaceAppsV1NamespacedStatefulSetRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling replaceAppsV1NamespacedStatefulSet.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling replaceAppsV1NamespacedStatefulSet.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling replaceAppsV1NamespacedStatefulSet.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.dryRun !== undefined) {
            queryParameters['dryRun'] = requestParameters.dryRun;
        }
        if (requestParameters.fieldManager !== undefined) {
            queryParameters['fieldManager'] = requestParameters.fieldManager;
        }
        if (requestParameters.fieldValidation !== undefined) {
            queryParameters['fieldValidation'] = requestParameters.fieldValidation;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = '**';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/apis/apps/v1/namespaces/{namespace}/statefulsets/{name}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: IoK8sApiAppsV1StatefulSetToJSON(requestParameters.body),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiAppsV1StatefulSetFromJSON(jsonValue));
    }
    /**
     * replace the specified StatefulSet
     */
    async replaceAppsV1NamespacedStatefulSet(requestParameters, initOverrides) {
        const response = await this.replaceAppsV1NamespacedStatefulSetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * replace scale of the specified StatefulSet
     */
    async replaceAppsV1NamespacedStatefulSetScaleRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling replaceAppsV1NamespacedStatefulSetScale.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling replaceAppsV1NamespacedStatefulSetScale.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling replaceAppsV1NamespacedStatefulSetScale.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.dryRun !== undefined) {
            queryParameters['dryRun'] = requestParameters.dryRun;
        }
        if (requestParameters.fieldManager !== undefined) {
            queryParameters['fieldManager'] = requestParameters.fieldManager;
        }
        if (requestParameters.fieldValidation !== undefined) {
            queryParameters['fieldValidation'] = requestParameters.fieldValidation;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = '**';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/apis/apps/v1/namespaces/{namespace}/statefulsets/{name}/scale`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: IoK8sApiAutoscalingV1ScaleToJSON(requestParameters.body),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiAutoscalingV1ScaleFromJSON(jsonValue));
    }
    /**
     * replace scale of the specified StatefulSet
     */
    async replaceAppsV1NamespacedStatefulSetScale(requestParameters, initOverrides) {
        const response = await this.replaceAppsV1NamespacedStatefulSetScaleRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * replace status of the specified StatefulSet
     */
    async replaceAppsV1NamespacedStatefulSetStatusRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling replaceAppsV1NamespacedStatefulSetStatus.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling replaceAppsV1NamespacedStatefulSetStatus.');
        }
        if (requestParameters.body === null || requestParameters.body === undefined) {
            throw new runtime.RequiredError('body', 'Required parameter requestParameters.body was null or undefined when calling replaceAppsV1NamespacedStatefulSetStatus.');
        }
        const queryParameters = {};
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.dryRun !== undefined) {
            queryParameters['dryRun'] = requestParameters.dryRun;
        }
        if (requestParameters.fieldManager !== undefined) {
            queryParameters['fieldManager'] = requestParameters.fieldManager;
        }
        if (requestParameters.fieldValidation !== undefined) {
            queryParameters['fieldValidation'] = requestParameters.fieldValidation;
        }
        const headerParameters = {};
        headerParameters['Content-Type'] = '**';
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/apis/apps/v1/namespaces/{namespace}/statefulsets/{name}/status`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: IoK8sApiAppsV1StatefulSetToJSON(requestParameters.body),
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApiAppsV1StatefulSetFromJSON(jsonValue));
    }
    /**
     * replace status of the specified StatefulSet
     */
    async replaceAppsV1NamespacedStatefulSetStatus(requestParameters, initOverrides) {
        const response = await this.replaceAppsV1NamespacedStatefulSetStatusRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * watch individual changes to a list of ControllerRevision. deprecated: use the \'watch\' parameter with a list operation instead.
     */
    async watchAppsV1ControllerRevisionListForAllNamespacesRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters.allowWatchBookmarks !== undefined) {
            queryParameters['allowWatchBookmarks'] = requestParameters.allowWatchBookmarks;
        }
        if (requestParameters._continue !== undefined) {
            queryParameters['continue'] = requestParameters._continue;
        }
        if (requestParameters.fieldSelector !== undefined) {
            queryParameters['fieldSelector'] = requestParameters.fieldSelector;
        }
        if (requestParameters.labelSelector !== undefined) {
            queryParameters['labelSelector'] = requestParameters.labelSelector;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.resourceVersion !== undefined) {
            queryParameters['resourceVersion'] = requestParameters.resourceVersion;
        }
        if (requestParameters.resourceVersionMatch !== undefined) {
            queryParameters['resourceVersionMatch'] = requestParameters.resourceVersionMatch;
        }
        if (requestParameters.timeoutSeconds !== undefined) {
            queryParameters['timeoutSeconds'] = requestParameters.timeoutSeconds;
        }
        if (requestParameters.watch !== undefined) {
            queryParameters['watch'] = requestParameters.watch;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/apis/apps/v1/watch/controllerrevisions`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApimachineryPkgApisMetaV1WatchEventFromJSON(jsonValue));
    }
    /**
     * watch individual changes to a list of ControllerRevision. deprecated: use the \'watch\' parameter with a list operation instead.
     */
    async watchAppsV1ControllerRevisionListForAllNamespaces(requestParameters = {}, initOverrides) {
        const response = await this.watchAppsV1ControllerRevisionListForAllNamespacesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * watch individual changes to a list of DaemonSet. deprecated: use the \'watch\' parameter with a list operation instead.
     */
    async watchAppsV1DaemonSetListForAllNamespacesRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters.allowWatchBookmarks !== undefined) {
            queryParameters['allowWatchBookmarks'] = requestParameters.allowWatchBookmarks;
        }
        if (requestParameters._continue !== undefined) {
            queryParameters['continue'] = requestParameters._continue;
        }
        if (requestParameters.fieldSelector !== undefined) {
            queryParameters['fieldSelector'] = requestParameters.fieldSelector;
        }
        if (requestParameters.labelSelector !== undefined) {
            queryParameters['labelSelector'] = requestParameters.labelSelector;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.resourceVersion !== undefined) {
            queryParameters['resourceVersion'] = requestParameters.resourceVersion;
        }
        if (requestParameters.resourceVersionMatch !== undefined) {
            queryParameters['resourceVersionMatch'] = requestParameters.resourceVersionMatch;
        }
        if (requestParameters.timeoutSeconds !== undefined) {
            queryParameters['timeoutSeconds'] = requestParameters.timeoutSeconds;
        }
        if (requestParameters.watch !== undefined) {
            queryParameters['watch'] = requestParameters.watch;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/apis/apps/v1/watch/daemonsets`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApimachineryPkgApisMetaV1WatchEventFromJSON(jsonValue));
    }
    /**
     * watch individual changes to a list of DaemonSet. deprecated: use the \'watch\' parameter with a list operation instead.
     */
    async watchAppsV1DaemonSetListForAllNamespaces(requestParameters = {}, initOverrides) {
        const response = await this.watchAppsV1DaemonSetListForAllNamespacesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * watch individual changes to a list of Deployment. deprecated: use the \'watch\' parameter with a list operation instead.
     */
    async watchAppsV1DeploymentListForAllNamespacesRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters.allowWatchBookmarks !== undefined) {
            queryParameters['allowWatchBookmarks'] = requestParameters.allowWatchBookmarks;
        }
        if (requestParameters._continue !== undefined) {
            queryParameters['continue'] = requestParameters._continue;
        }
        if (requestParameters.fieldSelector !== undefined) {
            queryParameters['fieldSelector'] = requestParameters.fieldSelector;
        }
        if (requestParameters.labelSelector !== undefined) {
            queryParameters['labelSelector'] = requestParameters.labelSelector;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.resourceVersion !== undefined) {
            queryParameters['resourceVersion'] = requestParameters.resourceVersion;
        }
        if (requestParameters.resourceVersionMatch !== undefined) {
            queryParameters['resourceVersionMatch'] = requestParameters.resourceVersionMatch;
        }
        if (requestParameters.timeoutSeconds !== undefined) {
            queryParameters['timeoutSeconds'] = requestParameters.timeoutSeconds;
        }
        if (requestParameters.watch !== undefined) {
            queryParameters['watch'] = requestParameters.watch;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/apis/apps/v1/watch/deployments`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApimachineryPkgApisMetaV1WatchEventFromJSON(jsonValue));
    }
    /**
     * watch individual changes to a list of Deployment. deprecated: use the \'watch\' parameter with a list operation instead.
     */
    async watchAppsV1DeploymentListForAllNamespaces(requestParameters = {}, initOverrides) {
        const response = await this.watchAppsV1DeploymentListForAllNamespacesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * watch changes to an object of kind ControllerRevision. deprecated: use the \'watch\' parameter with a list operation instead, filtered to a single item with the \'fieldSelector\' parameter.
     */
    async watchAppsV1NamespacedControllerRevisionRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling watchAppsV1NamespacedControllerRevision.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling watchAppsV1NamespacedControllerRevision.');
        }
        const queryParameters = {};
        if (requestParameters.allowWatchBookmarks !== undefined) {
            queryParameters['allowWatchBookmarks'] = requestParameters.allowWatchBookmarks;
        }
        if (requestParameters._continue !== undefined) {
            queryParameters['continue'] = requestParameters._continue;
        }
        if (requestParameters.fieldSelector !== undefined) {
            queryParameters['fieldSelector'] = requestParameters.fieldSelector;
        }
        if (requestParameters.labelSelector !== undefined) {
            queryParameters['labelSelector'] = requestParameters.labelSelector;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.resourceVersion !== undefined) {
            queryParameters['resourceVersion'] = requestParameters.resourceVersion;
        }
        if (requestParameters.resourceVersionMatch !== undefined) {
            queryParameters['resourceVersionMatch'] = requestParameters.resourceVersionMatch;
        }
        if (requestParameters.timeoutSeconds !== undefined) {
            queryParameters['timeoutSeconds'] = requestParameters.timeoutSeconds;
        }
        if (requestParameters.watch !== undefined) {
            queryParameters['watch'] = requestParameters.watch;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/apis/apps/v1/watch/namespaces/{namespace}/controllerrevisions/{name}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApimachineryPkgApisMetaV1WatchEventFromJSON(jsonValue));
    }
    /**
     * watch changes to an object of kind ControllerRevision. deprecated: use the \'watch\' parameter with a list operation instead, filtered to a single item with the \'fieldSelector\' parameter.
     */
    async watchAppsV1NamespacedControllerRevision(requestParameters, initOverrides) {
        const response = await this.watchAppsV1NamespacedControllerRevisionRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * watch individual changes to a list of ControllerRevision. deprecated: use the \'watch\' parameter with a list operation instead.
     */
    async watchAppsV1NamespacedControllerRevisionListRaw(requestParameters, initOverrides) {
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling watchAppsV1NamespacedControllerRevisionList.');
        }
        const queryParameters = {};
        if (requestParameters.allowWatchBookmarks !== undefined) {
            queryParameters['allowWatchBookmarks'] = requestParameters.allowWatchBookmarks;
        }
        if (requestParameters._continue !== undefined) {
            queryParameters['continue'] = requestParameters._continue;
        }
        if (requestParameters.fieldSelector !== undefined) {
            queryParameters['fieldSelector'] = requestParameters.fieldSelector;
        }
        if (requestParameters.labelSelector !== undefined) {
            queryParameters['labelSelector'] = requestParameters.labelSelector;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.resourceVersion !== undefined) {
            queryParameters['resourceVersion'] = requestParameters.resourceVersion;
        }
        if (requestParameters.resourceVersionMatch !== undefined) {
            queryParameters['resourceVersionMatch'] = requestParameters.resourceVersionMatch;
        }
        if (requestParameters.timeoutSeconds !== undefined) {
            queryParameters['timeoutSeconds'] = requestParameters.timeoutSeconds;
        }
        if (requestParameters.watch !== undefined) {
            queryParameters['watch'] = requestParameters.watch;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/apis/apps/v1/watch/namespaces/{namespace}/controllerrevisions`.replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApimachineryPkgApisMetaV1WatchEventFromJSON(jsonValue));
    }
    /**
     * watch individual changes to a list of ControllerRevision. deprecated: use the \'watch\' parameter with a list operation instead.
     */
    async watchAppsV1NamespacedControllerRevisionList(requestParameters, initOverrides) {
        const response = await this.watchAppsV1NamespacedControllerRevisionListRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * watch changes to an object of kind DaemonSet. deprecated: use the \'watch\' parameter with a list operation instead, filtered to a single item with the \'fieldSelector\' parameter.
     */
    async watchAppsV1NamespacedDaemonSetRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling watchAppsV1NamespacedDaemonSet.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling watchAppsV1NamespacedDaemonSet.');
        }
        const queryParameters = {};
        if (requestParameters.allowWatchBookmarks !== undefined) {
            queryParameters['allowWatchBookmarks'] = requestParameters.allowWatchBookmarks;
        }
        if (requestParameters._continue !== undefined) {
            queryParameters['continue'] = requestParameters._continue;
        }
        if (requestParameters.fieldSelector !== undefined) {
            queryParameters['fieldSelector'] = requestParameters.fieldSelector;
        }
        if (requestParameters.labelSelector !== undefined) {
            queryParameters['labelSelector'] = requestParameters.labelSelector;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.resourceVersion !== undefined) {
            queryParameters['resourceVersion'] = requestParameters.resourceVersion;
        }
        if (requestParameters.resourceVersionMatch !== undefined) {
            queryParameters['resourceVersionMatch'] = requestParameters.resourceVersionMatch;
        }
        if (requestParameters.timeoutSeconds !== undefined) {
            queryParameters['timeoutSeconds'] = requestParameters.timeoutSeconds;
        }
        if (requestParameters.watch !== undefined) {
            queryParameters['watch'] = requestParameters.watch;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/apis/apps/v1/watch/namespaces/{namespace}/daemonsets/{name}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApimachineryPkgApisMetaV1WatchEventFromJSON(jsonValue));
    }
    /**
     * watch changes to an object of kind DaemonSet. deprecated: use the \'watch\' parameter with a list operation instead, filtered to a single item with the \'fieldSelector\' parameter.
     */
    async watchAppsV1NamespacedDaemonSet(requestParameters, initOverrides) {
        const response = await this.watchAppsV1NamespacedDaemonSetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * watch individual changes to a list of DaemonSet. deprecated: use the \'watch\' parameter with a list operation instead.
     */
    async watchAppsV1NamespacedDaemonSetListRaw(requestParameters, initOverrides) {
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling watchAppsV1NamespacedDaemonSetList.');
        }
        const queryParameters = {};
        if (requestParameters.allowWatchBookmarks !== undefined) {
            queryParameters['allowWatchBookmarks'] = requestParameters.allowWatchBookmarks;
        }
        if (requestParameters._continue !== undefined) {
            queryParameters['continue'] = requestParameters._continue;
        }
        if (requestParameters.fieldSelector !== undefined) {
            queryParameters['fieldSelector'] = requestParameters.fieldSelector;
        }
        if (requestParameters.labelSelector !== undefined) {
            queryParameters['labelSelector'] = requestParameters.labelSelector;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.resourceVersion !== undefined) {
            queryParameters['resourceVersion'] = requestParameters.resourceVersion;
        }
        if (requestParameters.resourceVersionMatch !== undefined) {
            queryParameters['resourceVersionMatch'] = requestParameters.resourceVersionMatch;
        }
        if (requestParameters.timeoutSeconds !== undefined) {
            queryParameters['timeoutSeconds'] = requestParameters.timeoutSeconds;
        }
        if (requestParameters.watch !== undefined) {
            queryParameters['watch'] = requestParameters.watch;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/apis/apps/v1/watch/namespaces/{namespace}/daemonsets`.replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApimachineryPkgApisMetaV1WatchEventFromJSON(jsonValue));
    }
    /**
     * watch individual changes to a list of DaemonSet. deprecated: use the \'watch\' parameter with a list operation instead.
     */
    async watchAppsV1NamespacedDaemonSetList(requestParameters, initOverrides) {
        const response = await this.watchAppsV1NamespacedDaemonSetListRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * watch changes to an object of kind Deployment. deprecated: use the \'watch\' parameter with a list operation instead, filtered to a single item with the \'fieldSelector\' parameter.
     */
    async watchAppsV1NamespacedDeploymentRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling watchAppsV1NamespacedDeployment.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling watchAppsV1NamespacedDeployment.');
        }
        const queryParameters = {};
        if (requestParameters.allowWatchBookmarks !== undefined) {
            queryParameters['allowWatchBookmarks'] = requestParameters.allowWatchBookmarks;
        }
        if (requestParameters._continue !== undefined) {
            queryParameters['continue'] = requestParameters._continue;
        }
        if (requestParameters.fieldSelector !== undefined) {
            queryParameters['fieldSelector'] = requestParameters.fieldSelector;
        }
        if (requestParameters.labelSelector !== undefined) {
            queryParameters['labelSelector'] = requestParameters.labelSelector;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.resourceVersion !== undefined) {
            queryParameters['resourceVersion'] = requestParameters.resourceVersion;
        }
        if (requestParameters.resourceVersionMatch !== undefined) {
            queryParameters['resourceVersionMatch'] = requestParameters.resourceVersionMatch;
        }
        if (requestParameters.timeoutSeconds !== undefined) {
            queryParameters['timeoutSeconds'] = requestParameters.timeoutSeconds;
        }
        if (requestParameters.watch !== undefined) {
            queryParameters['watch'] = requestParameters.watch;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/apis/apps/v1/watch/namespaces/{namespace}/deployments/{name}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApimachineryPkgApisMetaV1WatchEventFromJSON(jsonValue));
    }
    /**
     * watch changes to an object of kind Deployment. deprecated: use the \'watch\' parameter with a list operation instead, filtered to a single item with the \'fieldSelector\' parameter.
     */
    async watchAppsV1NamespacedDeployment(requestParameters, initOverrides) {
        const response = await this.watchAppsV1NamespacedDeploymentRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * watch individual changes to a list of Deployment. deprecated: use the \'watch\' parameter with a list operation instead.
     */
    async watchAppsV1NamespacedDeploymentListRaw(requestParameters, initOverrides) {
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling watchAppsV1NamespacedDeploymentList.');
        }
        const queryParameters = {};
        if (requestParameters.allowWatchBookmarks !== undefined) {
            queryParameters['allowWatchBookmarks'] = requestParameters.allowWatchBookmarks;
        }
        if (requestParameters._continue !== undefined) {
            queryParameters['continue'] = requestParameters._continue;
        }
        if (requestParameters.fieldSelector !== undefined) {
            queryParameters['fieldSelector'] = requestParameters.fieldSelector;
        }
        if (requestParameters.labelSelector !== undefined) {
            queryParameters['labelSelector'] = requestParameters.labelSelector;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.resourceVersion !== undefined) {
            queryParameters['resourceVersion'] = requestParameters.resourceVersion;
        }
        if (requestParameters.resourceVersionMatch !== undefined) {
            queryParameters['resourceVersionMatch'] = requestParameters.resourceVersionMatch;
        }
        if (requestParameters.timeoutSeconds !== undefined) {
            queryParameters['timeoutSeconds'] = requestParameters.timeoutSeconds;
        }
        if (requestParameters.watch !== undefined) {
            queryParameters['watch'] = requestParameters.watch;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/apis/apps/v1/watch/namespaces/{namespace}/deployments`.replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApimachineryPkgApisMetaV1WatchEventFromJSON(jsonValue));
    }
    /**
     * watch individual changes to a list of Deployment. deprecated: use the \'watch\' parameter with a list operation instead.
     */
    async watchAppsV1NamespacedDeploymentList(requestParameters, initOverrides) {
        const response = await this.watchAppsV1NamespacedDeploymentListRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * watch changes to an object of kind ReplicaSet. deprecated: use the \'watch\' parameter with a list operation instead, filtered to a single item with the \'fieldSelector\' parameter.
     */
    async watchAppsV1NamespacedReplicaSetRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling watchAppsV1NamespacedReplicaSet.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling watchAppsV1NamespacedReplicaSet.');
        }
        const queryParameters = {};
        if (requestParameters.allowWatchBookmarks !== undefined) {
            queryParameters['allowWatchBookmarks'] = requestParameters.allowWatchBookmarks;
        }
        if (requestParameters._continue !== undefined) {
            queryParameters['continue'] = requestParameters._continue;
        }
        if (requestParameters.fieldSelector !== undefined) {
            queryParameters['fieldSelector'] = requestParameters.fieldSelector;
        }
        if (requestParameters.labelSelector !== undefined) {
            queryParameters['labelSelector'] = requestParameters.labelSelector;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.resourceVersion !== undefined) {
            queryParameters['resourceVersion'] = requestParameters.resourceVersion;
        }
        if (requestParameters.resourceVersionMatch !== undefined) {
            queryParameters['resourceVersionMatch'] = requestParameters.resourceVersionMatch;
        }
        if (requestParameters.timeoutSeconds !== undefined) {
            queryParameters['timeoutSeconds'] = requestParameters.timeoutSeconds;
        }
        if (requestParameters.watch !== undefined) {
            queryParameters['watch'] = requestParameters.watch;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/apis/apps/v1/watch/namespaces/{namespace}/replicasets/{name}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApimachineryPkgApisMetaV1WatchEventFromJSON(jsonValue));
    }
    /**
     * watch changes to an object of kind ReplicaSet. deprecated: use the \'watch\' parameter with a list operation instead, filtered to a single item with the \'fieldSelector\' parameter.
     */
    async watchAppsV1NamespacedReplicaSet(requestParameters, initOverrides) {
        const response = await this.watchAppsV1NamespacedReplicaSetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * watch individual changes to a list of ReplicaSet. deprecated: use the \'watch\' parameter with a list operation instead.
     */
    async watchAppsV1NamespacedReplicaSetListRaw(requestParameters, initOverrides) {
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling watchAppsV1NamespacedReplicaSetList.');
        }
        const queryParameters = {};
        if (requestParameters.allowWatchBookmarks !== undefined) {
            queryParameters['allowWatchBookmarks'] = requestParameters.allowWatchBookmarks;
        }
        if (requestParameters._continue !== undefined) {
            queryParameters['continue'] = requestParameters._continue;
        }
        if (requestParameters.fieldSelector !== undefined) {
            queryParameters['fieldSelector'] = requestParameters.fieldSelector;
        }
        if (requestParameters.labelSelector !== undefined) {
            queryParameters['labelSelector'] = requestParameters.labelSelector;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.resourceVersion !== undefined) {
            queryParameters['resourceVersion'] = requestParameters.resourceVersion;
        }
        if (requestParameters.resourceVersionMatch !== undefined) {
            queryParameters['resourceVersionMatch'] = requestParameters.resourceVersionMatch;
        }
        if (requestParameters.timeoutSeconds !== undefined) {
            queryParameters['timeoutSeconds'] = requestParameters.timeoutSeconds;
        }
        if (requestParameters.watch !== undefined) {
            queryParameters['watch'] = requestParameters.watch;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/apis/apps/v1/watch/namespaces/{namespace}/replicasets`.replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApimachineryPkgApisMetaV1WatchEventFromJSON(jsonValue));
    }
    /**
     * watch individual changes to a list of ReplicaSet. deprecated: use the \'watch\' parameter with a list operation instead.
     */
    async watchAppsV1NamespacedReplicaSetList(requestParameters, initOverrides) {
        const response = await this.watchAppsV1NamespacedReplicaSetListRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * watch changes to an object of kind StatefulSet. deprecated: use the \'watch\' parameter with a list operation instead, filtered to a single item with the \'fieldSelector\' parameter.
     */
    async watchAppsV1NamespacedStatefulSetRaw(requestParameters, initOverrides) {
        if (requestParameters.name === null || requestParameters.name === undefined) {
            throw new runtime.RequiredError('name', 'Required parameter requestParameters.name was null or undefined when calling watchAppsV1NamespacedStatefulSet.');
        }
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling watchAppsV1NamespacedStatefulSet.');
        }
        const queryParameters = {};
        if (requestParameters.allowWatchBookmarks !== undefined) {
            queryParameters['allowWatchBookmarks'] = requestParameters.allowWatchBookmarks;
        }
        if (requestParameters._continue !== undefined) {
            queryParameters['continue'] = requestParameters._continue;
        }
        if (requestParameters.fieldSelector !== undefined) {
            queryParameters['fieldSelector'] = requestParameters.fieldSelector;
        }
        if (requestParameters.labelSelector !== undefined) {
            queryParameters['labelSelector'] = requestParameters.labelSelector;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.resourceVersion !== undefined) {
            queryParameters['resourceVersion'] = requestParameters.resourceVersion;
        }
        if (requestParameters.resourceVersionMatch !== undefined) {
            queryParameters['resourceVersionMatch'] = requestParameters.resourceVersionMatch;
        }
        if (requestParameters.timeoutSeconds !== undefined) {
            queryParameters['timeoutSeconds'] = requestParameters.timeoutSeconds;
        }
        if (requestParameters.watch !== undefined) {
            queryParameters['watch'] = requestParameters.watch;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/apis/apps/v1/watch/namespaces/{namespace}/statefulsets/{name}`.replace(`{${"name"}}`, encodeURIComponent(String(requestParameters.name))).replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApimachineryPkgApisMetaV1WatchEventFromJSON(jsonValue));
    }
    /**
     * watch changes to an object of kind StatefulSet. deprecated: use the \'watch\' parameter with a list operation instead, filtered to a single item with the \'fieldSelector\' parameter.
     */
    async watchAppsV1NamespacedStatefulSet(requestParameters, initOverrides) {
        const response = await this.watchAppsV1NamespacedStatefulSetRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * watch individual changes to a list of StatefulSet. deprecated: use the \'watch\' parameter with a list operation instead.
     */
    async watchAppsV1NamespacedStatefulSetListRaw(requestParameters, initOverrides) {
        if (requestParameters.namespace === null || requestParameters.namespace === undefined) {
            throw new runtime.RequiredError('namespace', 'Required parameter requestParameters.namespace was null or undefined when calling watchAppsV1NamespacedStatefulSetList.');
        }
        const queryParameters = {};
        if (requestParameters.allowWatchBookmarks !== undefined) {
            queryParameters['allowWatchBookmarks'] = requestParameters.allowWatchBookmarks;
        }
        if (requestParameters._continue !== undefined) {
            queryParameters['continue'] = requestParameters._continue;
        }
        if (requestParameters.fieldSelector !== undefined) {
            queryParameters['fieldSelector'] = requestParameters.fieldSelector;
        }
        if (requestParameters.labelSelector !== undefined) {
            queryParameters['labelSelector'] = requestParameters.labelSelector;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.resourceVersion !== undefined) {
            queryParameters['resourceVersion'] = requestParameters.resourceVersion;
        }
        if (requestParameters.resourceVersionMatch !== undefined) {
            queryParameters['resourceVersionMatch'] = requestParameters.resourceVersionMatch;
        }
        if (requestParameters.timeoutSeconds !== undefined) {
            queryParameters['timeoutSeconds'] = requestParameters.timeoutSeconds;
        }
        if (requestParameters.watch !== undefined) {
            queryParameters['watch'] = requestParameters.watch;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/apis/apps/v1/watch/namespaces/{namespace}/statefulsets`.replace(`{${"namespace"}}`, encodeURIComponent(String(requestParameters.namespace))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApimachineryPkgApisMetaV1WatchEventFromJSON(jsonValue));
    }
    /**
     * watch individual changes to a list of StatefulSet. deprecated: use the \'watch\' parameter with a list operation instead.
     */
    async watchAppsV1NamespacedStatefulSetList(requestParameters, initOverrides) {
        const response = await this.watchAppsV1NamespacedStatefulSetListRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * watch individual changes to a list of ReplicaSet. deprecated: use the \'watch\' parameter with a list operation instead.
     */
    async watchAppsV1ReplicaSetListForAllNamespacesRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters.allowWatchBookmarks !== undefined) {
            queryParameters['allowWatchBookmarks'] = requestParameters.allowWatchBookmarks;
        }
        if (requestParameters._continue !== undefined) {
            queryParameters['continue'] = requestParameters._continue;
        }
        if (requestParameters.fieldSelector !== undefined) {
            queryParameters['fieldSelector'] = requestParameters.fieldSelector;
        }
        if (requestParameters.labelSelector !== undefined) {
            queryParameters['labelSelector'] = requestParameters.labelSelector;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.resourceVersion !== undefined) {
            queryParameters['resourceVersion'] = requestParameters.resourceVersion;
        }
        if (requestParameters.resourceVersionMatch !== undefined) {
            queryParameters['resourceVersionMatch'] = requestParameters.resourceVersionMatch;
        }
        if (requestParameters.timeoutSeconds !== undefined) {
            queryParameters['timeoutSeconds'] = requestParameters.timeoutSeconds;
        }
        if (requestParameters.watch !== undefined) {
            queryParameters['watch'] = requestParameters.watch;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/apis/apps/v1/watch/replicasets`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApimachineryPkgApisMetaV1WatchEventFromJSON(jsonValue));
    }
    /**
     * watch individual changes to a list of ReplicaSet. deprecated: use the \'watch\' parameter with a list operation instead.
     */
    async watchAppsV1ReplicaSetListForAllNamespaces(requestParameters = {}, initOverrides) {
        const response = await this.watchAppsV1ReplicaSetListForAllNamespacesRaw(requestParameters, initOverrides);
        return await response.value();
    }
    /**
     * watch individual changes to a list of StatefulSet. deprecated: use the \'watch\' parameter with a list operation instead.
     */
    async watchAppsV1StatefulSetListForAllNamespacesRaw(requestParameters, initOverrides) {
        const queryParameters = {};
        if (requestParameters.allowWatchBookmarks !== undefined) {
            queryParameters['allowWatchBookmarks'] = requestParameters.allowWatchBookmarks;
        }
        if (requestParameters._continue !== undefined) {
            queryParameters['continue'] = requestParameters._continue;
        }
        if (requestParameters.fieldSelector !== undefined) {
            queryParameters['fieldSelector'] = requestParameters.fieldSelector;
        }
        if (requestParameters.labelSelector !== undefined) {
            queryParameters['labelSelector'] = requestParameters.labelSelector;
        }
        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }
        if (requestParameters.pretty !== undefined) {
            queryParameters['pretty'] = requestParameters.pretty;
        }
        if (requestParameters.resourceVersion !== undefined) {
            queryParameters['resourceVersion'] = requestParameters.resourceVersion;
        }
        if (requestParameters.resourceVersionMatch !== undefined) {
            queryParameters['resourceVersionMatch'] = requestParameters.resourceVersionMatch;
        }
        if (requestParameters.timeoutSeconds !== undefined) {
            queryParameters['timeoutSeconds'] = requestParameters.timeoutSeconds;
        }
        if (requestParameters.watch !== undefined) {
            queryParameters['watch'] = requestParameters.watch;
        }
        const headerParameters = {};
        if (this.configuration && this.configuration.apiKey) {
            headerParameters["authorization"] = this.configuration.apiKey("authorization"); // BearerToken authentication
        }
        const response = await this.request({
            path: `/apis/apps/v1/watch/statefulsets`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);
        return new runtime.JSONApiResponse(response, (jsonValue) => IoK8sApimachineryPkgApisMetaV1WatchEventFromJSON(jsonValue));
    }
    /**
     * watch individual changes to a list of StatefulSet. deprecated: use the \'watch\' parameter with a list operation instead.
     */
    async watchAppsV1StatefulSetListForAllNamespaces(requestParameters = {}, initOverrides) {
        const response = await this.watchAppsV1StatefulSetListForAllNamespacesRaw(requestParameters, initOverrides);
        return await response.value();
    }
}
